import { useSelector } from 'react-redux';
import { Navigate, Outlet, useLocation } from 'react-router-dom';

const AppointmentGate = ({ redirectTo = '/makeappointment' }) => {
  const location = useLocation();
  const userState = useSelector((state) => state.user);

  const isAppointmentBooked = Boolean(
    userState?.response?.isAppointment || userState?.user?.isAppointment
  );

  return isAppointmentBooked
    ? <Outlet />
    : <Navigate to={redirectTo} state={{ from: location }} replace />;
};

export default AppointmentGate;

